import {
    BaseXYAxisChartOptions,
    LegendOptions,
    MetaInfoOptions,
} from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';

import { HyperSpaceAxisBubbleChartWidgetOptions } from './types';

export class HyperSpaceAxisBubbleChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceAxisBubbleChartWidgetOptions {
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        grid: {
            enabled: true,
        },
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };
}
